// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_jM0Sz","points":"points_mPkrs","has-points":"has-points_AYfQr"};